import { render, staticRenderFns } from "./ClearCartButton.vue?vue&type=template&id=1af985ac&scoped=true"
var script = {}
import style0 from "./ClearCartButton.vue?vue&type=style&index=0&id=1af985ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af985ac",
  null
  
)

export default component.exports